import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { Store } from "@ngrx/store";
import {
  app_mst_role_RowClass,
  TenantRoleService,
  PricingSchemeService,
  ClientSidePermissionPricingSchemeRoleLinkContainerModel,
} from "blg-akaun-ts-lib";
import { SessionSelectors } from "../../../../../modules/session/session-controller/selectors";
import { SessionStates } from "../../../../../modules/session/session-controller/states";
import { ViewColumnComponent } from "../../../../../view-column.component";
import { AppConfig } from "../../../../../visa";
import { SubSink } from "subsink2";
import { PermissionFacade } from "../../../facades/permission.facade";
import { PermissionStates } from "../../../permission-controller/root";
import { RolePricingSchemeLinkActions } from "../../../role-pricing-scheme-link-controler/actions";
import { RolePricingSchemeLinkSelectors } from "../../../role-pricing-scheme-link-controler/selectors";

interface LocalState {
  deactivateReturn: boolean;
}

@Component({
  selector: "app-role-pricing-scheme-link-edit",
  templateUrl: "./role-pricing-scheme-link-edit.component.html",
  styleUrls: ["./role-pricing-scheme-link-edit.component.css"],
  providers: [ComponentStore],
})
export class RolePricingSchemeLinkEditComponent extends ViewColumnComponent {
  protected readonly index = 1;
  private localState: LocalState;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(
    (state) => state.localState.deactivateReturn
  );
  readonly AppletLoginSubjectLink$ = this.sessionStore.select(
    SessionSelectors.selectAppletLoginSubjectLink
  );
  readonly userRank$ = this.sessionStore.select(
    SessionSelectors.selectUserRank
  );

  appletGuid = sessionStorage.getItem("appletGuid");
  selectedRolePricingSchemeLink$ = this.store.select(
    RolePricingSchemeLinkSelectors.selectRolePricingSchemeLink
  );

  prevIndex: number;
  private prevLocalState: any;
  public form: FormGroup;
  private subs = new SubSink();
  newRoleArr: app_mst_role_RowClass[] = [];
  roleArr: app_mst_role_RowClass[] = [];
  newPricingSchemeArr: any[] = [];
  pricingSchemeArr: any[] = [];
  tenantGuid: any;
  rank: any;
  selectedRolePricingSchemeLink: ClientSidePermissionPricingSchemeRoleLinkContainerModel;

  constructor(
    private tenantRoleService: TenantRoleService,
    private pricingSchemeService: PricingSchemeService,
    private viewColFacade: PermissionFacade,
    private fb: FormBuilder,
    private readonly sessionStore: Store<SessionStates>,
    private store: Store<PermissionStates>,
    private readonly componentStore: ComponentStore<{ localState: LocalState }>
  ) {
    super();
  }

  ngOnInit(): void {
    this.subs.sink = this.localState$.subscribe((a) => {
      this.localState = a;
      this.componentStore.setState({ localState: a });
    });
    this.subs.sink = this.viewColFacade.prevIndex$.subscribe(
      (resolve) => (this.prevIndex = resolve)
    );
    this.subs.sink = this.viewColFacade
      .prevLocalState$()
      .subscribe((resolve) => (this.prevLocalState = resolve));

    this.subs.sink = this.AppletLoginSubjectLink$.subscribe((session) => {
      if (session) {
        this.tenantGuid = session.tenant_guid.toString();
      }
    });

    this.subs.sink = this.userRank$.subscribe((rank) => {
      if (rank) {
        this.rank = rank;
      }
    });

    this.form = this.fb.group({
      role: ["", Validators.compose([Validators.required])],
      pricingScheme: ["", Validators.compose([Validators.required])],
      currentRole: [""],
      currPricingScheme: [""],
    });

    this.subs.sink = this.tenantRoleService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newRoleArr = this.roleArr = res.data.map((d) => d.app_mst_role);
      });

    this.subs.sink = this.pricingSchemeService
      .get(AppConfig.apiVisa)
      .subscribe((res) => {
        this.newPricingSchemeArr = this.pricingSchemeArr = res.data.map(
          (d) => d.bl_fi_mst_pricing_scheme_hdr
        );
      });

    this.subs.sink = this.selectedRolePricingSchemeLink$.subscribe((data) => {
      this.selectedRolePricingSchemeLink = data;
      this.form.patchValue({
        role: data.bl_applet_role_pricing_scheme_link.role_guid,
        pricingScheme:
          data.bl_applet_role_pricing_scheme_link.pricing_scheme_guid,
        currentRole: data.bl_applet_role_pricing_scheme_link.role_guid,
        currPricingScheme:
          data.bl_applet_role_pricing_scheme_link.pricing_scheme_guid,
      });
    });
  }

  applyRoleFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newRoleArr = this.roleArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  applyPricingSchemeFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newPricingSchemeArr = this.pricingSchemeArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateAdd: false,
      deactivateList: false,
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  onSubmit() {
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.applet_guid =
      this.appletGuid;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.role_guid =
      this.form.value.role;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.pricing_scheme_guid =
      this.form.value.pricingScheme;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.sales_price_read =
      true;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.sales_price_update =
      true;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.purchase_price_read =
      true;
    this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.purchase_price_update =
      true;

    this.store.dispatch(
      RolePricingSchemeLinkActions.updateRolePricingSchemeLinkInit({
        RolePricingSchemeLink: this.selectedRolePricingSchemeLink,
        rank: this.rank,
        tenantGuid: this.tenantGuid,
      })
    );
  }

  onDelete() {
    this.store.dispatch(
      RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkInit({
        guid: this.selectedRolePricingSchemeLink.bl_applet_role_pricing_scheme_link.guid.toString(),
        rank: this.rank,
        tenantGuid: this.tenantGuid,
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
